import {connect} from 'react-redux';

import {InboxJobModel} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getUserOwnedChannels} from '../../../../store/data/channels/channelsSelectors';
import {MassArchiveBanner} from './massArchiveBanner';

/*
 * Props.
 */

interface MassArchiveBannerContainerProps {
  job: InboxJobModel;
}

/*
 * Selectors.
 */

function getJob(_state: AppState, props: MassArchiveBannerContainerProps) {
  return props.job;
}

function makeGetJobChannel() {
  return createSelector([getUserOwnedChannels, getJob], (userOwnedChannels, job) => {
    const channel = userOwnedChannels.find((c) => c.inboxId === job.inboxId);
    if (!channel) {
      throw new Error('The channel for this job could not be found.');
    }

    return channel;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MassArchiveBannerContainerProps>()(() => ({
  channel: makeGetJobChannel(),
}));

export const MassArchiveBannerContainer = connect(mapStateToProps)(MassArchiveBanner);
